import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import OrganizationService from 'src/app/shared/services/organization.service';
import { DownloadReportRequest } from '../../organization/organization-models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { IdTag } from '../id-tag-model';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'adm-id-tag-download-usage-report-modal',
  templateUrl: './id-tag-download-usage-report-modal.component.html',
  styleUrls: ['./id-tag-download-usage-report-modal.component.scss'],
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatDatepickerModule],
})
export class IdTagDownloadUsageReportModalComponent {
  data = inject<{
    organizationId: number;
    idTag: IdTag;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<void, number>>(MatDialogRef);
  private organizationService = inject(OrganizationService);

  public downloadReportFormGroup: FormGroup = new FormGroup({
    startDate: new FormControl(moment().startOf('day'), [Validators.required]),
    endDate: new FormControl(moment().startOf('day'), [Validators.required]),
  });
  public loading: boolean;

  public downloadReport() {
    this.loading = true;
    const downloadReportModel: DownloadReportRequest = {
      from: moment(this.downloadReportFormGroup.value.startDate).format(),
      to: moment(this.downloadReportFormGroup.value.endDate).add(23, 'h').add(59, 'm').add(59, 's').format(),
      chargingStationLocations: [],
      organizationId: this.data.organizationId,
      idTagIds: [this.data.idTag.id],
    };

    this.organizationService
      .downloadConsumptionReport(downloadReportModel)
      .subscribe({
        next: result => {
          const fileName =
            'Forbrugsrapport fra ' +
            moment(downloadReportModel.from).format('DD-MM-YYYY') +
            ' til ' +
            moment(downloadReportModel.to).format('DD-MM-YYYY') +
            '.xlsx';

          saveAs(result, fileName);
          this.dialogRef.close();
        },
      })
      .add(() => {
        this.loading = false;
      });
  }
}
